var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 34.375H18.75C17.0241 34.375 15.625 35.7741 15.625 37.5V81.25C15.625 82.9759 17.0241 84.375 18.75 84.375H81.25C82.9759 84.375 84.375 82.9759 84.375 81.25V37.5C84.375 35.7741 82.9759 34.375 81.25 34.375Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9375 34.375V20.3125C35.9375 16.5829 37.4191 13.006 40.0563 10.3688C42.6935 7.73158 46.2704 6.25 50 6.25C53.7296 6.25 57.3065 7.73158 59.9437 10.3688C62.5809 13.006 64.0625 16.5829 64.0625 20.3125V34.375",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 64.0625C52.5888 64.0625 54.6875 61.9638 54.6875 59.375C54.6875 56.7862 52.5888 54.6875 50 54.6875C47.4112 54.6875 45.3125 56.7862 45.3125 59.375C45.3125 61.9638 47.4112 64.0625 50 64.0625Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.19048c845a15d68bd7df49bd73bdd72b.svg";
export { ForwardRef as ReactComponent };